"use strict";
import { Dropdown } from "../bootstrap-loader";
export default (() => {
  var _a;
  const BootstrapDropdown = ((_a = window.bootstrap) == null ? void 0 : _a.Dropdown) || Dropdown;
  if (false in window || !navigator.maxTouchPoints) {
    const dropdownTriggerList = document.querySelectorAll(
      '[data-bs-toggle="dropdown"][data-bs-trigger="hover"]'
    );
    const dropdownList = [...dropdownTriggerList].map((dropdownTriggerEl) => {
      const bsDropdown = new bootstrap.Dropdown(dropdownTriggerEl);
      dropdownTriggerEl.addEventListener("click", (e) => {
        if (e.currentTarget.getAttribute("href") === "#") {
          e.preventDefault();
        }
      });
      dropdownTriggerEl.addEventListener("mouseover", () => {
        dropdownTriggerEl.dataset.bsToggle = "dropdown-hover";
        bsDropdown.show();
        dropdownTriggerEl.blur();
      });
      dropdownTriggerEl.parentNode.addEventListener("mouseleave", () => {
        dropdownTriggerEl.dataset.bsToggle = "dropdown";
        bsDropdown.hide();
      });
      dropdownTriggerEl.addEventListener("focus", () => {
        bsDropdown.show();
      });
      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") {
          bsDropdown.hide();
        }
      });
    });
  }
})();
